"use strict";
Vue.http.headers.common['X-CSRF-TOKEN'] = $('#_token').val();

Vue.config.debug = process.env.NODE_ENV === 'development';

Vue.filter('dotdotdot', function (value, length) {
    if (value.length > length) return value.substring(0, length) + '....';
    else return value;
});

Vue.filter('startcase', function (value) {
    return _.startCase(value);
});

Vue.filter('extract', function (value, keyToExtract) {
    return value.map(function (item) {
        return item[keyToExtract]
    });
});

Vue.prototype.$nextTickPromise = () => {
  return new Promise(function(resolve, reject) {
    Vue.nextTick(() => {
      return resolve();
    });
  });
};

import "@babel/polyfill";

import vs_header from "./components/vsHeader";
import designer_tab from "./components/designerTab";
import product_selection_modal
    from "./components/designer_tab/controls/productSelectionModal";
import properties_window
    from "./components/designer_tab/controls/propertiesWindow";
import canvas_generator
    from "./components/designer_tab/controls/canvasGenerator";
import details_tab from "./components/details_tab/index";
import launch_tab from "./components/launch_tab/index";
import RequestService from "./services/RequestService";
import AuthService from "./services/AuthService";
import DesignerHelper from "./services/DesignerHelper";
import PricingService from "./services/PricingService";


new Vue({
    el: 'body',
    ready: function () {
        var self = this;
        this.ui_events();
        this.fetchFontsList();
        this.checkBrowserVersions();
        helpers.set_post_form();

        this.getRequestService().oAuthToken(function () {
            self.getAuthService().isUserLoggedIn(
                (user) => {
                    self.onUserLoggedIn(user);
                },
                () => {
                });
        });
    },
    events: {
        'recalculate-bounding-box': function () {
            this.$broadcast('recalculate-bounding-box');
        },
        'item-selected': function (data) {
            this.$broadcast('item-select');
            this.$broadcast('force-select');
        },
        'details-tab-next-clicked': function () {
            this.$broadcast('on-details-tab-next-clicked');
            if (this.isSublimationProduct()) {
                this.$broadcast('on-preview-rendering');
                this.$broadcast('on-force-preview-campaign');
            }
        },
        'item-removed': function (item_id) {
            this.removeColorsFromItem(item_id, this.currentSide);
        },
        'sublimation-drag-slide': function () {
            this.$broadcast('send-sublimation-image-back');
        },
        'sublimation-drag-stop': function () {
            this.$broadcast('send-sublimation-image-front');
        },
        'force-preview-rendering': function () {
            this.$broadcast('on-preview-rendering');
            this.$broadcast('on-force-preview-campaign');
        },
        'on-post-force-preview-campaign': function () {
            this.$broadcast('post-force-preview-campaign');
        },
        'on-side-changed': function (currentSide) {
            this.$broadcast('side-changed', currentSide);
        },
        'on-user-logged-in': function (user) {
            this.onUserLoggedIn(user);
        },
        'selling_price_updated': function () {
            this.$broadcast('selling_price_updated')
        },
        'on-user-logout': function () {
            this.onUserLoggedOut();
        },
        'on-open-select-product': function () {
            this.$broadcast('open-select-product');
        },
        'on-select-product': function () {
            this.$broadcast('on-select-product-clicked');
            this.$broadcast('on-additional-products-clear');
        },
        'on-open-login': function () {
            this.$broadcast('open-login');
        }
    },
    created: function () {
        this.initialize();
        this.designer_events();
    },
    watch: {
        'designerItems.front': {
            deep: true,
            handler: 'watchChanges'
        },
        'designerItems.back': {
            deep: true,
            handler: 'watchChanges'
        },
        'campaignData.campaign_dtg_auto_goal_drop': function (val) {
            this.$broadcast('on-dtg-enabled', val);
        },
        'campaignData': {
            deep: true,
            handler: function () {
                if (this.startRecordingNavigation) {
                    this.$set('warnBeforeNavigation', true);
                }
            }
        }
    },
    data: {
        product_categories: [],
        active_product_category: [],
        products_from_category: [],
        selectedProduct: null,
        artworkEnabled: false,  // Feature flag for enabling Noun Project artwork
        active_product: {},
        sides: ['front', 'back'],
        currentSide: 'front',
        currentColor: {},
        hoverDesignerColor: null,
        selectedItem: {},
        currentSelectedElement: [],
        designerItems: {
            front: [],
            back: []
        },
        groups: [],
        pricing: {
            APP_PRICING: {
                MARKUP_PERCENTAGE: 10
            },
            CAMPAIGN_PRICE: 0,
            COLOR_COST: [],
            DTG_PRICE: 0,
            GOAL: 50,
            SCREEN_CHARGE: 0,
            SUBLIMATION_PRICE: {
                FIRST_SIDE: 0,
                SECOND_SIDE: 0
            }
        },
        pricingObject: null,
        printer: {
            PRINTER_PRICING_RANGES: [],
            CURRENT_PRICING_MIN: 0,
            CURRENT_PRICING_MAX: 0
        },
        currentSelectedObject: [],
        campaignData: {
            isDraft: false,
            campaignId: null,
            createSimilar: false,
            campaignUniqueId: 'NEW',
            imageIdentifier: 'NEW',
            goal: 50,
            mainProduct: {
                product: {},
                front: {
                    designerItems: []
                },
                back: {
                    designerItems: []
                },
                currentColor: {},
                product_id: ''
            },
            pricing: {
                basePrice: 0.00,
                sellingPrice: 0.00,
                dtgPrice: 0.00
            },
            additionalProducts: [],
            campaign_name: '',
            campaign_description: '',
            campaign_url: '',
            campaign_tags: [],
            campaign_length: 0,
            campaign_end_date: '',
            campaign_end_date_obj: '',
            campaign_end_date_utc: '',
            hide_marketplace: false,
            campaign_auto_relaunch: true,
            campaign_page_timer: true,
            campaign_show_goal: true,
            campaign_auto_extend: true,
            campaign_dtg_auto_goal_drop: true,
            campaign_show_back_default: false,
            campaign_upsells: [],
            colors: {
                totalColors: [],
                totalFrontColors: [],
                totalBackColors: []
            },
            design: {
                front: {
                    original: '',
                    upscaled: '',
                    offsets: {
                        top: 0,
                        left: 0
                    }
                },
                back: {
                    original: '',
                    upscaled: '',
                    offsets: {
                        top: 0,
                        left: 0
                    }
                }
            },
            fonts: {
                front: [{
                    font: 'Exo',
                    times: 1
                }],
                back: [{
                    font: 'Exo',
                    times: 1
                }]
            },
            purchases: {
                products: [],
                buyer: {
                    email: '',
                    name: '',
                    address: '',
                    apt: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: ''
                },
                payment: {
                    cc: {
                        token: '',
                        cc_bin: '',
                        currency: 'USD'
                    }
                }
            },
            accept_terms: false,
            api_order: false,
            manual_order: false,
            email_list: '',
            category: '',
            source_id: null,
            force_dtg: false,
            auto_import_to_shopify: false,
            auto_set_visibility: false,
            import_back_images: true,
            shopify_collection: '',
            shopifyDomain: '',
            domain_id: ''
        },
        currentSelectedProduct: {},
        slider: null,
        designCanvasFront: '',
        designCanvasBack: '',
        productDesignerCanvasFront: '',
        productDesignerCanvasBack: '',
        all_products: [],
        preview: {
            activeSide: 'front',
            front: {
                large: '',
                thumbnail: ''
            },
            back: {
                large: '',
                thumbnail: ''
            }
        },
        userTimezone: '',
        warnBeforeNavigation: false,
        startRecordingNavigation: false,
        fontsListFromAPI: {},
        elementsIndex: {
            front: 0,
            back: 0
        },
        lastArtworkFetchTime: null,
        manualOrder: false,
        category: null,
        apiOrder: false,
        shipping_rates: {},
        vendorToken: {
            vendor: '',
            token: ''
        },
        resetImageIdentifierForCS: false,
        trackImageIdentifierforCS: false,
        dtgGoalCheckCount: 10,
        categories: [],
        service: {
            auth: {
                object: null,
                oAuthInfo: null,
                events: {
                    onStep3Open: false
                }
            },
            request: {
                object: null,
            },
            user: {
                object: null
            },
            designer: {
                object: null
            },
            pricing: {
                object: null
            }
        },
        isDTGProduct: false,
        shopify: {
            collections: [],
            isPaymentSetup: true,
            publishAutomatically: true
        },
        coBrandUpChargeAmount: 0.00,
        custom_discounts:[]
    },
    methods: {
        removeColorsFromItem(item_id, side){
            var idx = _.findIndex(this.designerItems[side], function (item) {
                    return item.id == item_id;
                }), self = this,
                element = this.designerItems[side][idx];

            if (element.type == 'IMAGE') {
                _.forEach(element.colors, function (color) {
                    self.removeColors(color, side);
                });
            } else if (element.type == 'TEXT') {
                this.removeColors(element.element.fill, side);
                if (parseInt(element.element.stroke_width, 10) > 0)
                    this.removeColors(element.element.stroke, side);
            } else if (element.type == 'ARTWORK') {
                this.removeColors(element.element.fill, side);
            }

            if (this.selectedItem.id == item_id) {
                this.unSelectAllControls();
                this.$set('selectedItem', {});
            }

            this.designerItems[side].splice(idx, 1);

            self.$broadcast('on-item-removed');
            self.recalculateMainProductPricing();
        },
        checkForceDTG: function () {
            var totalColorsCount = this.campaignData.colors.totalColors.length;
            this.campaignData.force_dtg = (this.isAPIOrder() == false && totalColorsCount > 9 && this.isProductAMug() == false);
        },
        initialize(){
            var request = new RequestService(),
                auth = new AuthService(request),
                designer = new DesignerHelper(),
                pricing = new PricingService(request);

            this.service.request.object = request;
            this.service.auth.object = auth;
            this.service.designer.object = designer;
            this.service.pricing.object = pricing;

            this.checkPageSegment();
        },
        getRequestService(){
            return this.service.request.object;
        },
        getDesignerHelper(){
            return this.service.designer.object;
        },
        getAuthService(){
            return this.service.auth.object;
        },
        getPricingService(){
            return this.service.pricing.object;
        },
        checkPageSegment: function () {
            var segments = URI().segment();

            if (segments[0] == "manual.order") {
                this.manualOrder = true;
                this.apiOrder = false;
            } else if (segments[0] == "api.order") {
                this.manualOrder = false;
                this.apiOrder = true;
            } else {
                this.manualOrder = false;
                this.apiOrder = false;
            }
        },
        onPostProductsFetch(){
            if (this.manualOrder === true) {
                this.apiOrder = false;
                this.campaignData.goal = 0;
                this.getShippingRates();
                this.setCampaignDetailsForManualOrder();
                this.getVendorToken();
            } else {
                if (this.apiOrder === true) {
                    this.campaignData.api_order = true;
                    this.campaignData.goal = 1;
                    this.$broadcast('page-segment-defined');
                } else {
                    this.apiOrder = false;
                }
                this.manualOrder = false;
                var segments = URI().segment();
                if (segments.length > 1) {
                    //Load Draft
                    var campaignId = segments[segments.length - 1];
                    this.importDraft(campaignId);
                }
            }
        },
        async onUserLoggedIn(user) {
            let tzPromise = this.getUserTimezone(),
                cobrandPromise = this.getCoBrandUpChargeAmount(),
                discountPromise = this.getCustomProductDiscounts();

            this.$set('service.user.object', user);
            this.$broadcast('user-logged-in', user);

            if (this.service.auth.events.onStep3Open === true) {
                this.service.auth.events.onStep3Open = false;
                var currentIndex = $('#form_wizard_1').bootstrapWizard('currentIndex');
                if (currentIndex == 0)
                    this.$broadcast('on-designer-tab-launch-campaign-clicked');
                else
                    this.$broadcast('on-details-tab-next-clicked');
            }

            await Promise.all([tzPromise, cobrandPromise, discountPromise]);

            this.$broadcast('user-initialized');
        },
        onUserLoggedOut(){
            this.$set('service.user.object', null);
            this.$broadcast('user-logged-out');

            if($('#form_wizard_1').bootstrapWizard('currentIndex') === 2) {
              $('#form_wizard_1').bootstrapWizard('show', 1);
            }
        },
        checkBrowserVersions: function () {
            $.reject({
                reject: {
                    safari: $.browser.versionX <= 8, // Apple Safari
                    chrome: false, // Google Chrome
                    firefox: false, // Mozilla Firefox
                    msie: false, // Microsoft Internet Explorer
                    opera: false, // Opera
                    konqueror: false, // Konqueror (Linux)
                    unknown: false // Everything else
                },
                imagePath: 'https://cdnjs.cloudflare.com/ajax/libs/jReject/1.1.4/images/',
                display: ['firefox', 'chrome', 'safari'],
                closeCookie: true
            });
        },
        async getCoBrandUpChargeAmount() {
            let response = await Vue.http.get(this.getRequestService().ajaxBase + 'cobrand-upcharge-amount');

            this.coBrandUpChargeAmount = parseFloat(response.data.amount);

            return response;
        },
        async getCustomProductDiscounts() {
            let response = await Vue.http.get(this.getRequestService().ajaxBase + 'custom-discounts')

            this.custom_discounts = response.data;

            return response;
        },
        getVendorToken: function () {
            var that = this;
            Vue.http.get(this.getRequestService().ajaxBase + 'vendor-token').then(function (response) {
                var res = response.data;
                if (res.status == 'SUCCESS') {
                    that.$set('vendorToken', res.data);
                    cardProvider.init(that.vendorToken.vendor, that.vendorToken.token);
                }
            });
        },
        setCampaignDetailsForManualOrder: function () {
            var dateObj = moment();
            var title = 'Manual-Order-Campaign-' + dateObj.format('x');
            this.$set('campaignData.campaign_name', title);
            this.$set('campaignData.campaign_description', title);
            this.$set('campaignData.campaign_url', _.kebabCase(title));
            this.$set('campaignData.campaign_tags', []);
            this.$set('campaignData.campaign_length', 1);
            this.$set('campaignData.campaign_end_date', dateObj.add(1, 'd').format("dddd, MMM. DD YYYY - HH A"));
            this.$set('campaignData.campaign_end_date_obj', dateObj.format());
            this.$set('campaignData.campaign_end_date_utc', dateObj.format('x'));
            this.$set('campaignData.campaign_auto_relaunch', false);
            this.$set('campaignData.campaign_page_timer', false);
            this.$set('campaignData.campaign_show_goal', false);
            this.$set('campaignData.campaign_auto_extend', false);
            this.$set('campaignData.campaign_dtg_auto_goal_drop', false);
            this.$set('campaignData.campaign_show_back_default', false);
        },
        getShippingRates: function () {
            var that = this;
            Vue.http.get('/manual.order/shipping-rates').then(function (response) {
                var res = response.data;
                if (res.status == 'SUCCESS') {
                    that.$set('shipping_rates', res.data);
                }
            });
        },
        validateCampaign: function () {
            var validations = [],
                campaignData = this.campaignData;

            // this.recalculateMainProductPricing();

            if (campaignData.campaign_name == '') {
                validations.push('Campaign Name');
            } else {
                if (campaignData.campaign_name.length < 4) {
                    validations.push('Campaign Name cannot be less than 4 characters');
                }
            }

            if (this.$root.campaignData.isDraft === false) {
                if (campaignData.campaign_description == '') {
                    validations.push('Campaign Description');
                } else {
                    var description_length = $($('#campaign_description').val()).text().length;
                    if (description_length > 300)
                        validations.push('Campaign Description cannot be more than 300 characters');
                }

                if (this.isAPIOrder() === false) {
                    if (+campaignData.pricing.sellingPrice < +campaignData.pricing.basePrice) {
                        validations.push('Selling Price cannot be lower than base cost.');
                    }

                    for (var i = 0; i < campaignData.additionalProducts.length; i++) {
                        if (+campaignData.additionalProducts[i].profit < 0) {
                            validations.push('Selling Price cannot be lower than base cost on any product.');
                        }
                    }

                    if (campaignData.campaign_dtg_auto_goal_drop) {
                        if (this.isSublimationProduct() == 0) {
                            if (+campaignData.pricing.sellingPrice < +campaignData.pricing.dtgPrice) {
                                validations.push('Selling Price cannot be lower than DTG cost while DTG/Auto Goal Drop is enabled.');
                            }

                            for (var i = 0; i < campaignData.additionalProducts.length; i++) {
                                if (+campaignData.additionalProducts[i].selling_price < +campaignData.additionalProducts[i].dtg_price) {
                                    validations.push('Selling Price on any product cannot be lower than DTG cost while DTG/Auto Goal Drop is enabled.');
                                }
                            }
                        }
                    }


                    if (campaignData.campaign_url == '') {
                        validations.push('Campaign URL Required');
                    }
                }

                var campaignTagsLength = $('#campaign_tags').val().split(',');
                
                if (campaignTagsLength.length > 3) {
                    validations.push('Campaign Tags cannot be more that 3');
                }

                if (campaignData.accept_terms === false) {
                    validations.push('Agree and Accept Terms of Services');
                }
            }

            return validations;
        },
        importDraft: function (campaignId) {
            var that = this;
            helpers.showProcessing(true);
            NProgress.start();
            Vue.http.get(this.$root.getRequestService().ajaxBase + 'import-draft/' + campaignId, {}).then(function (response) {
                var res = response.data;
                if (res.status == 'SUCCESS') {
                    var draftInfo = JSON.parse(base64.decode(res.data)),
                      sides = ['front', 'back'];

                    _.each(sides, side => {
                      _.each(draftInfo.mainProduct[side].designerItems, item => {
                        if (!item.element) {
                          item.element = { x: 0, y: 0 };

                          item.span.height = parseInt(draftInfo.mainProduct.product.dimensions[side].offsets.height)

                          item.span.width = parseInt(draftInfo.mainProduct.product.dimensions[side].offsets.width)
                        }
                      });
                    });

                    that.$set('campaignData', draftInfo);
                    that.$broadcast('on-prepare-images-draft-loaded');
                    that.$broadcast('draft-loaded', draftInfo);

                    that.campaignData.accept_terms = false;

                    if (res.campaign_status == 'DRAFT') {
                        that.campaignData.isDraft = true;
                        that.campaignData.createSimilar = false;
                    } else {
                        that.campaignData.isDraft = false;
                        that.campaignData.createSimilar = true;
                    }

                    if ( ! draftInfo.mainProduct.front.designerItems.length) {
                        that.currentSide = 'back';
                    }

                    NProgress.done();
                } else {
                    helpers.hideProcessing(true);
                    helpers.alert(res.message, function () {
                        if (res.message == "Campaign was created using the Old designer which is not supported anymore. This campaign needs to be recreated using the new designer.")
                            window.location = "/design.beta";
                    });
                    NProgress.done();
                }
            });
        },
        async getUserTimezone() {
            let response = await Vue.http.get(this.$root.getRequestService().ajaxBase + 'user-timezone');

            this.$set('userTimezone', response.data.timezone);

            return response;
        },
        formatDate: function (date) {
            var timezone = this.userTimezone == "" ? "US/Eastern" : this.userTimezone;
            return moment.tz(date, timezone).format("MM-DD-YYYY z");
        },
        ui_events: function () {
            var that = this;
            $('#form_wizard_1').bootstrapWizard({
                'nextSelector': '.step-button-next',
                'previousSelector': '.step-button-previous',
                onTabClick: function (tab, navigation, index, clickedIndex) {
                    if (index == 0) {
                        if ((that.isSublimationProduct() && that.isApparel() && !that.doesFrontAndBackDesignExist())) {
                            helpers.alert('Sublimation Apparel products require both the front and back design.');
                            return false;
                        }

                        if (clickedIndex == 1) {
                            that.$broadcast('on-designer-tab-next-clicked');
                        } else if (clickedIndex == 2) {
                            if ((that.userLoggedIn && that.manualOrder === false) || that.manualOrder === true) {
                                that.service.auth.events.onStep3Open = false;
                                that.$broadcast('on-designer-tab-launch-campaign-clicked');
                            }
                            else {
                                that.service.auth.events.onStep3Open = true;
                                that.$broadcast('open-login');
                            }

                        }
                    } else if (index == 1) {
                        if (clickedIndex == 0) {
                            that.$broadcast('on-details-tab-back-clicked');
                        } else if (clickedIndex == 2) {
                            if ((that.userLoggedIn && that.manualOrder === false) || that.manualOrder === true) {
                                that.service.auth.events.onStep3Open = false;
                                that.$broadcast('on-details-tab-next-clicked');
                            }
                            else {
                                that.service.auth.events.onStep3Open = true;
                                that.$broadcast('open-login');
                            }
                        }
                    } else if (index == 2) {
                        if (clickedIndex == 0) {
                            $('#form_wizard_1').bootstrapWizard('show', 0);
                        } else if (clickedIndex == 1) {
                            $('#form_wizard_1').bootstrapWizard('show', 1);
                        }
                    }

                    return false;
                },
                onTabShow: function (tab, navigation, index) {
                    var $total = navigation.find('li').length;
                    var $current = index + 1;
                    var $percent = ($current / $total) * 100;
                    $('#form_wizard_1').find('.progress-bar-success').css({
                        width: $percent + '%'
                    });
                    $('html, body').animate({scrollTop: 0}, 500);
                    switch (index) {
                        case 0:
                            location.hash = "designer";
                            break;
                        case 1:
                            location.hash = "products";
                            break;
                        case 2:
                            location.hash = "details";
                            break;
                    }
                    $('[data-toggle="tooltip"]').tooltip({html: true});
                    $('[data-toggle="popover"]').popover({
                        html: true
                    });
                }
            });

            $('#product-list-colors').mCustomScrollbar({
                setHeight: '350px'
            });

            window.onhashchange = function (e) {
                $('.form-wizard [data-toggle="tab"][href="' + location.hash + '"]').trigger('click');
            };

            $(window).on('beforeunload', function () {
                if (that.warnBeforeNavigation) {
                    return 'There are unsaved changes to this campaign.'
                }
            });
        },
        async designer_events() {
          helpers.showProcessing(true);
          NProgress.start();

          await Promise.all([
            this.getProductGroups(),
            this.getProductCategories(),
            this.getPricing(),
            this.getPrinterPricingRanges(),
          ]);

          helpers.hideProcessing();
          NProgress.done();
        },
        async getProductGroups() {
            let response = await Vue.http.get(this.$root.getRequestService().ajaxBase + 'product-groups');

            this.$set('groups', response.data);

            return response;
        },
        async getProductCategories() {
          let response = await Vue.http.get(this.$root.getRequestService().ajaxBase + 'product-categories?api_campaign=' + this.apiOrder),
            rep = response.data,
            default_category = rep[0],
            default_product = this.parseProduct(default_category.category_products[0]);

          this.$set('product_categories', rep);
          this.$set('active_product_category', default_category);
          this.$set('all_products', _.flatten(_.map(rep, 'category_products')));

          this.selectProduct(default_product, false);
          this.$broadcast('products-loaded');
          this.onPostProductsFetch();
          this.recalculateMainProductPricing();

          return response;
        },
        recalculateMainProductPricing(){
            this.setMainProductPricing();
            this.$broadcast('pricing-recalculated');
        },
        watchChanges: function () {
            var that = this;
            that.checkForceDTG();
            if (this.isSublimationProduct() === false)
                that.$broadcast('canvas-changed', function () {
                    that.updateCampaignDataWithMainProductInfo();
                    that.getDesignOffsets();
                    that.recalculateMainProductPricing();
                    that.$set('startRecordingNavigation', true);
                });
            else {
                that.getDesignOffsets();
                that.recalculateMainProductPricing();
                that.$set('startRecordingNavigation', true);
            }

            if (this.trackImageIdentifierforCS === true)
                if (this.campaignData.createSimilar === true && this.resetImageIdentifierForCS === false) {
                    this.campaignData.imageIdentifier = 'NEW';
                    this.campaignData.campaignUniqueId = 'NEW';
                    this.resetImageIdentifierForCS = true;
                }
        },
        selectProduct: function (product, forceSelection) {
            forceSelection = (forceSelection == undefined ? false : forceSelection);
            this.$set('selectedProduct', product);
            this.$set('active_product', product);

            var sortedColors = this.$root.getDesignerHelper().sortColors(product.product.product_colors);

            //Setting the Goal and Auto Goal Drop based on the Product selection
            this.isDTGProduct = !!product.product.dtg_drop_is_locked;
            this.$set('campaignData.goal', this.isDTGProduct ? 10 : 50);
            this.$set('campaignData.campaign_dtg_auto_goal_drop', !this.isDTGProduct);

            this.$set('currentColor', sortedColors[0]);
            this.checkForceDTG();
            this.updateCampaignDataWithMainProductInfo();
            this.$broadcast('on-product-select', this.selectedProduct, this.product_categories, forceSelection);
            this.recalculateMainProductPricing();
            this.$broadcast('on-auto-align');

            this.doProductAlerts(product.product);
        },
        doProductAlerts(product){
            if (product.product_type == "JEWELRY") {
                var html = "When creating Jewelry graphics <b>AVOID</b>: <br><br> " +
                    "<ul>" +
                    "<li>Small Text</li>" +
                    "<li>Small Details</li>" +
                    "<li>Intricate Details</li>" +
                    "<li>Cursive Font</li>" +
                    "</ul> " +
                    "(Remember the printable area is approximately 1 inch wide)";
                helpers.alert(html);
            }

            if (product.product_type == "CAPS" && product.is_embroidery) {
                var html = "When creating Hat graphics <b>AVOID</b>:<br><br>" +
                    "<ul>" +
                    "<li>Small Text (Text must be 1/4 inch)</li>" +
                    "<li>Small Details</li>" +
                    "<li>Intricate Details</li>" +
                    "<li>Cursive Font</li>" +
                    "<li>Color Fading</li>" +
                    "<li>Complex Shadowing</li>" +
                    "<li>Grey Scale</li>" +
                    "<li>Overlapping Colors</li>" +
                    "</ul>" +
                    "<br>(Remember these graphics need to be stitched)";
                helpers.alert(html);
            }
        },
        updateCampaignDataWithMainProductInfo: function () {
            this.$set('campaignData.mainProduct', {
                currentColor: this.currentColor,
                product: this.selectedProduct,
                front: {
                    designerItems: this.designerItems.front
                },
                back: {
                    designerItems: this.designerItems.back
                },
                product_id: this.selectedProduct.product.id
            });

            this.$broadcast('color-changed');
        },
        parseProduct: function (productObj) {
            var products = productObj.products;
            return {
                product: products,
                image: {
                    front: {
                        original: products.front_base,
                        thumbnail: products.front_preview,
                        large: products.front_base_large
                    },
                    back: {
                        original: products.back_base,
                        thumbnail: products.back_preview,
                        large: products.back_base_large
                    }
                },
                mock_index: -1,
                mock_id: -1,
                product_type: 'PRODUCT',
                dimensions: {
                    front: {
                        offsets: {
                            height: products.front_height + 'px',
                            width: products.front_width + 'px',
                            left: products.front_left + 'px',
                            top: products.front_top + 'px'
                        },
                        image: {
                            width: products.front_image_width + 'px',
                            height: products.front_image_height + 'px'
                        }
                    },
                    back: {
                        offsets: {
                            height: products.back_height + 'px',
                            width: products.back_width + 'px',
                            left: products.back_left + 'px',
                            top: products.back_top + 'px'
                        },
                        image: {
                            width: products.back_image_width + 'px',
                            height: products.back_image_height + 'px'
                        }
                    }
                }
            };
        },
        getSelectedObject: function () {
            var that = this;
            if (this.currentSide == "front") {
                this.currentSelectedObject = _.find(that.designerItems.front, function (item) {
                    return item.id == that.currentSelectedElement;
                });
            } else {
                this.currentSelectedObject = _.find(that.designerItems.back, function (item) {
                    return item.id == that.currentSelectedElement;
                });
            }
        },
        async addElementToDesigner(element) {
            var that = this;
            this.unSelectAllControls();
            element.id = 'item-' + this.currentSide + '-' + (this.currentSide == 'front' ? this.elementsIndex.front : this.elementsIndex.back);

            if (this.currentSide == 'front') {
                this.elementsIndex.front++;
            } else {
                this.elementsIndex.back++;
            }

            if (this.designerItems[this.currentSide].length > 0) {
                var maxIndex = _.max(this.designerItems[this.currentSide], function (item) {
                    return item.span.index;
                });

                element.span.index = maxIndex.span.index + 1;
            } else {
                element.span.index = 11;
            }

            element.index = (this.currentSide == 'front' ? this.designerItems.front.length : this.designerItems.back.length);
            this.currentSide == 'front' ? this.designerItems.front.push(element) : this.designerItems.back.push(element);

            if (element.type == 'IMAGE') {
                _.forEach(element.colors, function (color) {
                    that.storeColors(color, that.currentSide);
                })
            } else if (element.type == 'TEXT') {
                this.storeColors(element.element.fill, this.currentSide);
                if (parseInt(element.element.stroke_width, 10) > 0)
                    this.storeColors(element.element.stroke, this.currentSide);
            } else if (element.type == 'ARTWORK') {
                this.storeColors(element.element.fill, this.currentSide);
            }
            this.recalculateMainProductPricing();
            this.$broadcast('on-item-added');

            await this.$nextTickPromise();

            this.outputDesign();
        },
        unSelectAllControls: function () {
            this.$broadcast('item-unselect');
        },
        selectItem: function () {
            this.$broadcast('item-select');
            this.$broadcast('force-select');
        },
        async getPricing() {
          if (this.pricingObject == null) {
            let goal = 10,
              response = await Vue.http.get(this.$root.getRequestService().ajaxBase + 'pricing', { goal }),
              rep = response.data;

            this.$set('pricingObject', rep);
            this.$set('pricing', rep);

            return response;
          }

          return Promise.resolve();
        },
        async getPrinterPricingRanges() {
          var ranges = this.printer.PRINTER_PRICING_RANGES;

          if (ranges.length == 0) {
            let response = await Vue.http.get(this.$root.getRequestService().ajaxBase + 'printer-pricing-ranges', {}),
              res = response.data;

            if (res.status == 'SUCCESS') {
              this.$set('printer.PRINTER_PRICING_RANGES', res.data);
            }

            return response;
          }

          return Promise.resolve();
        },
        setPricingRanges: function (goal) {
            var that = this,
                currentGoal = goal,
                ranges = that.printer.PRINTER_PRICING_RANGES;

            _.each(ranges, function (range) {
                if (range.min <= currentGoal && range.max >= currentGoal) {
                    that.$set('printer.CURRENT_PRICING_MIN', range.min);
                    that.$set('printer.CURRENT_PRICING_MAX', range.max);
                }
            });
        },
        getPricingRangeByGoal(goal){
            var that = this,
                currentGoal = goal < 10 ? 10 : goal,
                ranges = that.printer.PRINTER_PRICING_RANGES;

            return _.find(ranges, function (range) {
                return (range.quantity_min <= currentGoal && range.quantity_max >= currentGoal);
            });
        },
        setMainProductPricing: function () {
            if (this.selectedProduct) {
                var product = this.selectedProduct.product,
                    dtgPrice = this.getPricingByProduct(product, 1, "MAIN"),
                    price = this.getPricingByProduct(product, this.campaignData.goal, "MAIN"),
                    sellingPrice = parseFloat(this.campaignData.pricing.sellingPrice);

                price = dtgPrice < price ? dtgPrice : price;

                this.$set('campaignData.pricing', {
                    basePrice: price,
                    sellingPrice: (this.isManualOrder()) ? price : ((isNaN(sellingPrice) || sellingPrice == 0.00) ? parseFloat(product.suggested_price).toFixed(2) : sellingPrice),
                    dtgPrice: dtgPrice
                });
            } else {
                this.$set('campaignData.pricing', {
                    //Defaults
                    basePrice: 14.00,
                    sellingPrice: 21.99,
                    dtgPrice: 14.00
                });
            }
        },
        getDTGPricing: function (product, goal) {
            if (product) {
                var frontColorCount = this.designerItems.front.length,
                    backColorCount = this.designerItems.back.length,
                    dtgPrice = parseFloat(this.pricing.DTG_PRICE),
                    dtgPriceSecondSide = parseFloat(this.pricing.DTG_PRICE_SECOND_SIDE),
                    embroideryPrice = parseFloat(this.pricing.EMBROIDERY_PRICE),
                    dtg_price = 0.00,
                    price_shirt = parseFloat(product.avg_cost),
                    dtgPromoStartDate = this.pricing.DTG_PROMO_START_DATE,
                    dtgPromoEndDate = this.pricing.DTG_PROMO_END_DATE,
                    dtgPromoPriceSingleSide = this.pricing.DTG_PROMO_SINGLE_SIDE,
                    dtgPromoPriceSecondSide = this.pricing.DTG_PROMO_SECOND_SIDE;

                if (dtgPromoStartDate != '' & dtgPromoEndDate != '') {
                    var startDateObj = moment.tz(dtgPromoStartDate, 'UTC'),
                        endDateObj = moment.tz(dtgPromoEndDate, 'UTC'),
                        currentDateObj = moment(moment().tz('UTC').format());

                    if ((currentDateObj.isSame(startDateObj) || currentDateObj.isAfter(startDateObj)) && (currentDateObj.isSame(endDateObj) || currentDateObj.isBefore(endDateObj))) {
                        dtgPrice = parseFloat(dtgPromoPriceSingleSide);
                        dtgPriceSecondSide = parseFloat(dtgPromoPriceSecondSide);
                    }
                }

                if ((product.sublimation == 1)
                    || (product.sublimation == 0 && product.special_printing == 1 && product.is_embroidery == 0)) {
                    if (frontColorCount > 0 && backColorCount > 0) {
                        dtg_price = parseFloat(product.sublimation_double_side_price);
                    } else {
                        dtg_price = parseFloat(product.sublimation_single_side_price);
                    }
                    dtg_price += price_shirt;

                    let customDiscount = this.getCustomProductDiscount(product.id);

                    if(customDiscount) {
                        dtg_price -= customDiscount.amount;
                    }

                } else {
                    if (product.is_embroidery == 1) {
                        dtg_price = price_shirt + parseFloat(embroideryPrice);
                    } else {
                        dtg_price = price_shirt + parseFloat(dtgPrice);

                        if (frontColorCount > 0 && backColorCount > 0) {
                            dtg_price += parseFloat(dtgPriceSecondSide);
                        }
                    }
                }

                return +(parseFloat(dtg_price).toFixed(2));
            }
            return 0.00;
        },
        getCustomProductDiscount(productId){
            return this.custom_discounts.find((discount)=>{
                return discount.product_id === productId;
            })
        },
        productHasAddonCost: function (product) {
            return (product.special_printing == 1 && parseFloat(product.special_print_setup_costs) > 0);
        },
        getAddonCost: function (product, goal) {
            if (this.productHasAddonCost(product)) {
                var currentGoal = parseInt(goal, 10),
                    special_cost = parseFloat(product.special_print_setup_costs);
                if (currentGoal <= 20)
                    return parseFloat(special_cost / currentGoal);
            }
            return 0.00;
        },
        calculatePricing: function (product, goal) {
            var app_pricing = this.pricing.APP_PRICING,
                markup = parseInt(app_pricing.MARKUP_PERCENTAGE, 10),
                price = 0.00,
                pricing_shirt = parseFloat(product.avg_cost);

            var colorCount = this.campaignData.colors.totalColors.length,
                colorCountFront = this.campaignData.colors.totalFrontColors.length,
                colorCountBack = this.campaignData.colors.totalBackColors.length,
                garment_price = 0.00,
                campaign_price = parseFloat(this.pricing.CAMPAIGN_PRICE),
                shirtCount = (goal || this.campaignData.goal),
                pricingObject = this.getPricingRangeByGoal(goal),
                screenPrice = parseFloat(this.pricing.SCREEN_CHARGE),
                front_color_price = colorCountFront > 0 ? parseFloat(pricingObject['colors_' + colorCountFront] || 0) : 0.00,
                back_color_price = colorCountBack > 0 ? parseFloat(pricingObject['colors_' + colorCountBack] || 0) : 0.00;

            // // $3 Unisex Cotton Tee Promo
            // if (product.sku == 'G5000' && colorCount < 4 && goal >= 50) {
            //     let frontBaseCost = 5; //If updating the price here, also update on Pricing/PricingService.php:583
            //     let backBaseCost = 5;//If updating the price here, also update on Pricing/PricingService.php:583
            //
            //     if (colorCountFront > 0 && colorCountBack > 0)
            //         return frontBaseCost + backBaseCost;
            //     else
            //         return frontBaseCost;
            // }

            if (colorCount === 0) {
                price = (pricing_shirt + (campaign_price / shirtCount)) * ((100 + markup) / 100);
            } else {
                price = (pricing_shirt + (campaign_price / shirtCount) + (((screenPrice * colorCountFront) / shirtCount) + front_color_price) + (((screenPrice * colorCountBack) / shirtCount) + back_color_price)) * ((100 + markup) / 100);
            }

            price = (price + garment_price).toFixed(2);
            return price;
        },
        getPricingByProduct(productObj, goal){
            var twoSided = this.designerItems.front.length > 0 && this.designerItems.back.length > 0;

            var basePrice = twoSided ? productObj.two_sided_price : productObj.one_sided_price;

            basePrice += parseFloat(this.coBrandUpChargeAmount);

            return basePrice;
        },
        getSVGText: function (item) {
            var texts = item.value.split('\n'),
                textContent = [];
            for (var i = 0; i < texts.length; i++) {
                var dy = parseInt(item.element.font_size);
                textContent.push({
                    text: texts[i],
                    dy: dy
                });
            }

            return textContent;
        },
        storeColors: function (color, side) {
            var fullColorsIndex = _.findIndex(this.campaignData.colors.totalColors, function (item) {
                return item.hex == color;
            });

            if (fullColorsIndex > -1) {
                this.campaignData.colors.totalColors[fullColorsIndex]['times']++;
            } else {
                this.campaignData.colors.totalColors.push({
                    hex: color,
                    times: 1
                });
            }

            if (side == 'front') {
                var frontColorsIndex = _.findIndex(this.campaignData.colors.totalFrontColors, function (item) {
                    return item.hex == color;
                });
                if (frontColorsIndex > -1) {
                    this.campaignData.colors.totalFrontColors[frontColorsIndex]['times']++;
                } else {
                    this.campaignData.colors.totalFrontColors.push({
                        hex: color,
                        times: 1
                    });
                }
            } else {
                var backColorsIndex = _.findIndex(this.campaignData.colors.totalBackColors, function (item) {
                    return item.hex == color;
                });
                if (backColorsIndex > -1) {
                    this.campaignData.colors.totalBackColors[backColorsIndex]['times']++;
                } else {
                    this.campaignData.colors.totalBackColors.push({
                        hex: color,
                        times: 1
                    });
                }
            }
        },
        removeColors: function (color, side) {
            var fullColorsIndex = _.findIndex(this.campaignData.colors.totalColors, function (item) {
                return item.hex == color;
            });

            var occurrence = 0;
            if (fullColorsIndex > -1) {
                occurrence = this.campaignData.colors.totalColors[fullColorsIndex]['times'];
                if (occurrence == 1) {
                    this.campaignData.colors.totalColors.splice(fullColorsIndex, 1);
                } else {
                    this.campaignData.colors.totalColors[fullColorsIndex]['times']--;
                }
                occurrence = 0;
            }

            if (side == 'front') {
                var frontColorsIndex = _.findIndex(this.campaignData.colors.totalFrontColors, function (item) {
                    return item.hex == color;
                });

                if (frontColorsIndex > -1) {
                    occurrence = this.campaignData.colors.totalFrontColors[frontColorsIndex]['times'];
                    if (occurrence == 1) {
                        this.campaignData.colors.totalFrontColors.splice(frontColorsIndex, 1);
                    } else {
                        this.campaignData.colors.totalFrontColors[frontColorsIndex]['times']--;
                    }
                }
            } else {
                var backColorsIndex = _.findIndex(this.campaignData.colors.totalBackColors, function (item) {
                    return item.hex == color;
                });

                if (backColorsIndex > -1) {
                    occurrence = this.campaignData.colors.totalBackColors[backColorsIndex]['times'];
                    if (occurrence == 1) {
                        this.campaignData.colors.totalBackColors.splice(backColorsIndex, 1);
                    } else {
                        this.campaignData.colors.totalBackColors[backColorsIndex]['times']--;
                    }
                }
            }
        },
        storeFonts: function (side, font) {
            if (side == 'front') {
                var frontFontIndex = _.findIndex(this.campaignData.fonts.front, function (item) {
                    return item.font == font;
                });
                if (frontFontIndex > -1) {
                    this.campaignData.fonts.front[frontFontIndex]['times']++;
                } else {
                    this.campaignData.fonts.front.push({
                        font: font,
                        times: 1
                    });
                }
            } else {
                var backFontsIndex = _.findIndex(this.campaignData.fonts.back, function (item) {
                    return item.font == font;
                });

                if (backFontsIndex > -1) {
                    this.campaignData.fonts.back[backFontsIndex]['times']++;
                } else {
                    this.campaignData.fonts.back.push({
                        font: font,
                        times: 1
                    });
                }
            }
        },
        removeFonts: function (side, font) {
            if (side == 'front') {
                var frontFontIndex = _.findIndex(this.campaignData.fonts.front, function (item) {
                    return item.font == font;
                });

                var occurrence = 0;
                if (frontFontIndex > -1) {
                    occurrence = this.campaignData.fonts.front[frontFontIndex]['times'];
                    if (occurrence == 1) {
                        this.campaignData.fonts.front.splice(frontFontIndex, 1);
                    } else {
                        this.campaignData.fonts.front[frontFontIndex]['times']--;
                    }
                }
            } else {
                var backFontsIndex = _.findIndex(this.campaignData.fonts.back, function (item) {
                    return item.font == font;
                });

                if (backFontsIndex > -1) {
                    occurrence = this.campaignData.fonts.back[backFontsIndex]['times'];
                    if (occurrence == 1) {
                        this.campaignData.fonts.back.splice(backFontsIndex, 1);
                    } else {
                        this.campaignData.fonts.back[backFontsIndex]['times']--;
                    }
                }
            }
        },
        drawProductDesign: function (productId, side) {
            var canvas = null;
            if (side == 'front') {
                canvas = this.productDesignerCanvasFront;
                canvas.clear();
            } else {

            }
        },
        outputDesign: function (callback) {
            //Generating the Canvas Images before getting the output from them.
            var that = this;
            if (this.isSublimationProduct() === false) {
                var scaled_design_output_front = $('#quality_design_front')[0].toDataURL(),
                    scaled_design_output_back = $('#quality_design_back')[0].toDataURL();

                // that.$set('campaignData.design.front.original', design_output_front);
                that.$set('campaignData.design.front.upscaled', scaled_design_output_front);
                // that.$set('campaignData.design.back.original', design_output_back);
                that.$set('campaignData.design.back.upscaled', scaled_design_output_back);

                that.getDesignOffsets();
                that.$broadcast('design-ready');
                if (callback)
                    callback();
            }
        },
        getDesignOffsets: function () {
            var result = {
                front: {
                    top: 0,
                    left: 0
                },
                back: {
                    top: 0,
                    left: 0
                }
            };

            if (this.designerItems.front.length > 0) {
                var frontObjects = this.designerItems.front;
                for (var i = 0; i < frontObjects.length; ++i) {
                    var frontItem = frontObjects[i],
                        frontLeft = frontItem.span.left,
                        frontTop = frontItem.span.top;

                    if (this.$root.getDesignerHelper().radDeg(frontItem.rotate) > 0) {
                        frontLeft = frontItem.span.rotLeft;
                        frontTop = frontItem.span.rotTop;
                    }

                    result.front.left = (i == 0 ? frontLeft : (result.front.left < frontLeft ? result.front.left : frontLeft));
                    result.front.top = (i == 0 ? frontTop : (result.front.top < frontTop ? result.front.top : frontTop));
                }

                if (this.selectedProduct) {

                    if (this.isSublimationProduct() == 0) {
                        result.front.left = (result.front.left < 0 ? 0 : result.front.left);
                        result.front.top = (result.front.top < 0 ? 0 : result.front.top);
                    }
                }
            }

            if (this.designerItems.back.length > 0) {
                var backObjects = this.designerItems.back;
                for (var i = 0; i < backObjects.length; ++i) {
                    var backItem = backObjects[i],
                        backLeft = backItem.span.left,
                        backTop = backItem.span.top;

                    if (this.$root.getDesignerHelper().radDeg(backItem.rotate) > 0) {
                        backLeft = backItem.span.rotLeft;
                        backTop = backItem.span.rotTop;
                    }
                    result.back.left = (i == 0 ? backLeft : (result.back.left < backLeft ? result.back.left : backLeft));
                    result.back.top = (i == 0 ? backTop : (result.back.top < backTop ? result.back.top : backTop));
                }

                if (this.selectedProduct) {
                    if (this.selectedProduct.product.sublimation == 0) {
                        result.back.left = (result.back.left < 0 ? 0 : result.back.left);
                        result.back.top = (result.back.top < 0 ? 0 : result.back.top);
                    }
                }
            }

            this.$set('campaignData.design.front.offsets', result.front);
            this.$set('campaignData.design.back.offsets', result.back);
        },
        changePreviewSide: function (side) {
            this.preview.activeSide = side;
        },
        processSVGToRemoveWhitespace: function (svg) {
            var bB = svg.getBBox();
            svg.setAttribute('viewBox', bB.x + ',' + bB.y + ',' + bB.width + ',' + bB.height);
            return {
                svg: svg,
                height: bB.height,
                width: bB.width,
                viewBox: bB.x + ',' + bB.y + ',' + bB.width + ',' + bB.height
            };
        },
        setRotationCoordinates: function (item) {
            var currentSide = this.$root.currentSide,
                elementBoundingRect = $('#' + item.id).get(0).getBoundingClientRect(),
                designAreaBoundingRect = $('.design-area-' + currentSide).get(0).getBoundingClientRect();

            item.span.rotLeft = elementBoundingRect.left - designAreaBoundingRect.left;
            item.span.rotTop = elementBoundingRect.top - designAreaBoundingRect.top;
        },
        fetchFontsList: function () {
            $.get('https://www.googleapis.com/webfonts/v1/webfonts?key=' + this.$root.getDesignerHelper().googleFontsKey, res => {
              this.fontsListFromAPI = res.items;
            });
        },
        getFontURLByName: function (name) {
            var fontItem = _.find(this.$root.fontsListFromAPI, function (item) {
                return item.family.toLowerCase() == name.toLowerCase();
            });

            return _.values(fontItem.files);
        },
        isSublimationProduct: function () {
            if (this.selectedProduct) {
                return this.selectedProduct.product.sublimation == "1";
            }
        },
        isPhoneCaseProduct: function () {
            if (this.selectedProduct) {
                return (this.selectedProduct.product.is_phone_case == "1" || this.selectedProduct.product.has_perspectives == "1");
            }
        },
        clearDesignData: function (data) {
            var sides = ['front', 'back'];
            _.each(sides, function (side) {
                var designItems = data.mainProduct[side].designerItems,
                    imageItems = _.filter(designItems, function (item) {
                        return item.type == "IMAGE" || item.type == "ARTWORK";
                    });

                _.each(imageItems, function (item) {
                    if (item.type == "IMAGE") {
                        delete item.imageData.original_encoded;
                        delete item.imageData.thumbnail_encoded;
                    } else {
                        delete item.value;
                    }
                });
            });

            //Removing the Large Product Object which is not required to pass to the server
            delete data.mainProduct.product.product;

            return data;
        },
        isManualOrder: function () {
            return this.manualOrder;
        },
        getProductGroup: function (groupId) {
            var groups = this.$root.groups;

            return _.find(groups, function (group) {
                return group.id == groupId;
            });
        },
        artworkEnabled: function () {
            return this.artworkEnabled;
        },
        isEmbroideryProduct: function () {
            if (this.selectedProduct) {
                return this.selectedProduct.product.is_embroidery == "1";
            }
        },
        isSpecialPrint: function () {
            if (this.selectedProduct) {
                return this.selectedProduct.product.special_printing == "1";
            }
        },
        isDTGAndGoalDropEnabled: function () {
            return this.campaignData.campaign_dtg_auto_goal_drop === true;
        },
        isAPIOrder: function () {
            return this.apiOrder === true;
        },
        isCreateSimilar(){
            return this.campaignData.createSimilar === true;
        },
        isDraft(){
            return this.campaignData.isDraft === true;
        },
        isDTGForced(){
            if (this.isProductOkForDTG)
                return this.campaignData.force_dtg === true;
            return false;
        },
        goToOptionsPage(){
            window.parent.postMessage(JSON.stringify({event: 'GOTO_OPTIONS'}), 'https://' + window.location.host);
        },
        isProductAMug(){
            if (this.selectedProduct) {
                return this.selectedProduct.product.product_type == "MUGS";
            }
        },
        getVariants(){
            var mainProduct = this.$root.campaignData.mainProduct;
            if (mainProduct.product.hasOwnProperty('product')) {
                var additionalProducts = this.$root.campaignData.additionalProducts,
                    self = this,
                    variants = [],
                    mainProductId = mainProduct.product.product.id,
                    mainProductSizes = this.getSizesByProduct(mainProductId);

                _.each(mainProductSizes, function (size) {
                    variants.push({id: mainProductId, size: size});
                });

                _.each(additionalProducts, function (product) {
                    var productId = product.product,
                        productSizes = self.getSizesByProduct(productId);

                    _.each(productSizes, function (size) {
                        variants.push({id: productId, size: size});
                    });
                });

                return variants;
            }
            return [];
        },
        getVariantsByProduct(productId){
            var variants = this.getVariants();

            productId = productId ? productId : this.selectedProduct.product.id;

            return _.filter(variants, function (variant) {
                return variant.id == productId;
            });
        },
        getSizesByProduct(productId){
            productId = productId ? productId : this.selectedProduct.product.id;
            var product = this.getProductById(productId);
            return product.products.sizes.split(',');
        },
        getProductById(id){
            var products = _.flatten(_.pluck(this.$root.product_categories, 'category_products'));
            return _.find(products, function (p) {
                return p.product == id;
            });
        },
        isProductUSOnly(id){
            if (this.all_products.length > 0) {
                return this.all_products.filter(function (product) {
                        return product.products.id === id && product.products.us_only === 1;
                    }).length > 0;
            }
            return false;
        },
        isApparel(){
            if(this.selectedProduct){
                return this.selectedProduct.product.is_non_apparel == false;
            }
            return false;
        },
        doesFrontAndBackDesignExist(){
            let designItems = this.$root.designerItems;
            return (designItems.front.length > 0 && designItems.back.length > 0)
        }
    },
    components: {
        'vs-header': vs_header,
        'designer-tab': designer_tab,
        'default-product-selection-list': product_selection_modal,
        'property-panel': properties_window,
        'details-tab': details_tab,
        'campaign-launch': launch_tab,
        'canvas-generator': canvas_generator
    },
    computed: {
        showBackView: function () {
            if (this.selectedProduct) {

                if(this.selectedProduct.product.back_thumbnail_text == '') {
                    return false;
                }

                return this.selectedProduct.product.back_view == 'SHOW';
            }
        },
        userLoggedIn(){
            return this.service.user.object != null;
        },
        mainProduct(){
            if (this.campaignData.mainProduct)
                return this.campaignData.mainProduct.product.product;
        },
        isProductOkForDTG(){
            if (this.mainProduct)
                if ((this.mainProduct.is_embroidery == 0 || this.mainProduct.dtg_drop_is_locked == 0 || this.mainProduct.special_printing == 0) && this.isAPIOrder() == false)
                    return true;
            return false;
        },
        isMainProductDTGPrintableOnly() {
            if (this.mainProduct)
                return this.mainProduct.dtg_only == 1;
            return false
        },
        isMainProductUSOnly(){
            if (this.mainProduct) {
                return this.mainProduct.us_only === 1;
            }
            return false;
        },
    }
});


$(document).ready(function () {
    var designerHelper = new DesignerHelper();
    $('head').append("<link href='https://fonts.googleapis.com/css?family=" + designerHelper.googleFonts.stylesheet + "' rel='stylesheet' type='text/css'>");
});


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/index.js